import axios from "axios";
// Import setAlert action
import {
  REGISTER_SUCCESS,
  REGISTER_FAIL,
  GET_USER,
  AUTH_ERROR,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT,
  SET_USER,
} from "./types";
import setAuthToken from "../utils/setAuthToken";

export const setUserData = (user) => async (dispatch) => {
  console.log("SET USER", user);
  if (localStorage.token) {
    setAuthToken(localStorage.token);
  }

  console.log("SET USER", user);

  dispatch({
    type: SET_USER,
    payload: user,
  });
};

// Register User
export const register = ({ email, password }) => async (dispatch) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  const body = JSON.stringify({ email, password });

  try {
    const res = await axios.post(
      "https://african-marketplace4.herokuapp.com/api/auth/register",
      body,
      config
    );

    console.log("Register Response:", res);

    dispatch({
      type: REGISTER_SUCCESS,
      payload: res.data,
    });

    // DISPATCH LOAD USER ?
  } catch (err) {
    dispatch({
      type: REGISTER_FAIL,
    });
  }
};

// Login User
export const login = (email, password) => async (dispatch) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  const body = JSON.stringify({ email, password });

  try {
    const res = await axios.post(
      "https://african-marketplace4.herokuapp.com/api/auth/login",
      body,
      config
    );

    console.log("Login Response:", res);

    dispatch({
      type: LOGIN_SUCCESS,
      payload: res.data,
    });

    // DISPATCH LOAD USER ?
  } catch (err) {
    dispatch({
      type: LOGIN_FAIL,
    });
  }
};

// Logour / Clear state
export const logout = () => (dispatch) => {
  dispatch({
    type: LOGOUT,
  });
};

// export const getUser = (id) => async (dispatch) => {
//   if (localStorage.token) {
//     setAuthToken(localStorage.token);
//   }

//   try {
//     const res = await axios.get(
//       `https://african-marketplace4.herokuapp.com/api/users/${id}`
//     );
//     dispatch({
//       type: GET_USER,
//       payload: res.data,
//     });
//   } catch (err) {
//     dispatch({
//       type: AUTH_ERROR,
//     });
//   }
// };
